import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminPersonelItems, getPersonelItems } from '../../services/api';
import { PersonelValue } from '../../utils/common';

export const fetchPersonelValues = createAsyncThunk(
  'lov/fetchPersonelValues',
  async (currentModule: 'admin' | 'isg' | 'firm') => {
    if (currentModule === 'admin') {
      return await getAdminPersonelItems();
    }
    return await getPersonelItems();
  }
);

interface PersonelState {
  values: PersonelValue[];
  loading: boolean;
  error: string | null;
}

const initialState: PersonelState = {
  values: [],
  loading: false,
  error: null,
};

const personelSlice = createSlice({
  name: 'personel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPersonelValues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPersonelValues.fulfilled, (state, action) => {
        state.values = action.payload;
        state.loading = false;
      })
      .addCase(fetchPersonelValues.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default personelSlice.reducer;